$(() => {
  $(window).on("load", function () {
    const formElm = $(
      ".standalone_tools.s-step-about-your-business.questionnaire form",
    );

    if (formElm.length > 0)
      formElm.find("input[type=text]").filter(":visible:first").focus();
  });
});
